import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const RedoclyAPIBlock = makeShortcode("RedoclyAPIBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <RedoclyAPIBlock src="/firefly-services/docs/generative_fill.json" width="600px" disableSidebar scrollYOffset={64} generateCodeSamples="languages: [{lang: 'curl'}]" mdxType="RedoclyAPIBlock" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      